import { type UseQueryResult, useQuery } from 'react-query';
import {
  OptionAwardApprovalService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_OptionAwardListDto,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetOptionAwardApprovalList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType & {
    fromApproveDate?: string;
    toApproveDate?: string;
    fromPublishDate?: string;
    toPublishDate?: string;
    fromExpirationDate?: string;
    toExpirationDate?: string;
  }
  // filterData: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_OptionAwardListDto | undefined,
  unknown
> => {
  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    approvalStatusId,
    optionAcceptance,
    fromDate,
    toDate,
    createdFromDate,
    createdToDate,
    employeeStatusId,
    isEarlyExercisable,
    grantFromDate,
    grantToDate,
    fromApproveDate,
    toApproveDate,
    fromPublishDate,
    toPublishDate,
    fromExpirationDate,
    toExpirationDate,
    _force,
  } = tableInfo;

  const optionStatus = 0;

  const OptionParticipantList = useQuery(
    [
      'getOptionAwardApprovalList',
      approvalStatusId,
      fromDate,
      toDate,
      grantFromDate,
      grantToDate,
      employeeStatusId,
      optionStatus,
      optionAcceptance,
      createdFromDate,
      createdToDate,
      isEarlyExercisable,
      fromApproveDate,
      toApproveDate,
      fromPublishDate,
      toPublishDate,
      fromExpirationDate,
      toExpirationDate,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        OptionAwardApprovalService.getApiAwardApiAppOptionAwardApprovalOptionAwardList(
          approvalStatusId ?? [0],
          createdFromDate,
          createdToDate,
          grantFromDate,
          grantToDate,
          employeeStatusId ?? [0],
          optionStatus,
          optionAcceptance,
          isEarlyExercisable,
          fromApproveDate,
          toApproveDate,
          fromPublishDate,
          toPublishDate,
          fromExpirationDate,
          toExpirationDate,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return OptionParticipantList;
};

export default useGetOptionAwardApprovalList;
